import styled from 'styled-components';
import { rem } from 'polished';
var CtaButton = styled.div.withConfig({
  displayName: "CtaButton",
  componentId: "sc-1uw5fg-0"
})(["margin:", " 0;"], rem(16));
export default CtaButton;